<template>
  <div class="hello">
    <!-- <div>
      <a style="display: inline-block" target="_blank" href="http://live.xw100.com/">
        <img src="https://xwliveimage.oss-cn-beijing.aliyuncs.com/2023sj/12.png" alt="" />
      </a>
    </div> -->

    <div class="swiper-page" > 
      <div class="container-list" v-if="slideList.length > 1">
        <swiper v-model="slideList" v-if="slideList.length > 0" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in slideList" :key="index">
            <div class="container">
              <div>
                <img :src="item" alt="" />
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>

      <div style="width: 100%" v-if="slideList.length == 1">
        <img style="width: 100%;" :src="slideList[0]" alt="">
      </div>

    </div>

    <div class="superiorityDiv">
      <div class="superiorityTitle">学为优势</div>
      <div class="superiorityImg">
        <img src="@/assets/img/1.png" alt="" />
        <img src="@/assets/img/2.png" alt="" />
        <img src="@/assets/img/3.png" alt="" />
        <img src="@/assets/img/4.png" alt="" />
      </div>
    </div>

    <div class="curriculumSystem">
      <div class="curriculumSystemDiv">
        <div class="curriculumTitle">独家课程体系</div>
        <div class="titleExplain">
          <div class="titleExplainDiv">
            <span class="left">金字塔阶梯教学,</span>
            <span class="right">真正的因材施教</span>
          </div>
          <div class="titleExplainImg">
            <img class="lazy" src="@/assets/img/5.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="eduInformationDiv">
      <div class="superiorityTitle">教育资讯</div>

      <div class="informationDiv">

        <div class="inforContentDiv">
          <div class="informationLeft" >
            <div class="inforTopImg" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==0">
              <img :src="infor.picUrl" alt="">
            </div>

            <div class="inforDetailDiv" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==0">
              <div class="inforLeft">
                <div class="topDiv">置顶</div>
                <img src="@/assets/img/9.png" alt="">
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>

            </div>

            <div class="inforDetailDiv" style="margin-bottom: 0;" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==1">
              <div class="inforLeft">
                <div class="topDiv">热门</div>
                <img src="@/assets/img/8.png" alt="">
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>

            </div>

          </div>

          <div class="informationLeft">

            <div class="inforDetailDiv" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==2">
              <div class="inforLeft">
                <div class="topDiv topNum">01</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>

            <div class="inforDetailDiv" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==3">
              <div class="inforLeft">
                <div class="topDiv topNum">02</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>

            <div class="inforDetailDiv" style="margin-bottom: 0;" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==4">
              <div class="inforLeft">
                <div class="topDiv topNum">03</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>

            

          </div>

          <div class="informationLeft">

            <div class="inforDetailDiv" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==5">
              <div class="inforLeft">
                <div class="topDiv topNum">04</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>

            <div class="inforDetailDiv" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==6">
              <div class="inforLeft">
                <div class="topDiv topNum">05</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>

            <div class="inforDetailDiv" style="margin-bottom: 0;" v-for="(infor,i) in inforList" :key="infor.id" v-if="i==7">
              <div class="inforLeft">
                <div class="topDiv topNum">06</div>
              </div>
              <div class="inforRight">
                <div class="inforName" :title="infor.title">
                  <a target="_blank" :href="infor.link">{{ infor.title }}</a>
                </div>
                <div class="inforRemark" :title="infor.remark">{{infor.remark}}</div>
                <div class="infortime">发布于 {{infor.publishTime}}</div>
              </div>
            </div>
  
          </div>

        </div>

        <div class="lookMore">
          <a href="#/article">点击查看更多 >></a>
        </div>
        
      </div>
    </div>

  </div>
</template>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      path: this.newCommon["publicDef"]["newPath"],
      loading: {},
      swiperOptions: {
        loop: true, //无限循环
        autoplay: {
          //自动切换
          delay: 2000,
          stopOnLastSlide: false, //切换到最后一个slide时停止自动切换
          disableOnInteraction: true, //用户操作swiper之后，是否禁止自动切换。默认为true
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination", //若改变分页样式，需改变样式名字，默认为.swiper-pagination
          type: "bullets",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next1", //若改变右箭头样式，需改变名字，默认为.swiper-button-next
        //   prevEl: ".swiper-button-prev1", //若改变左箭头样式，需改变名字，默认为.swiper-button-prev
        // },

      
      },
      //数据列表
      slideList: [],
      inforList: [],
    };
  },
  props: {
    // msg: String
  },
  mounted() {
    this.getBanner();
    this.getInformation();

  },
  methods: {
    getBanner() {
      this.openFullScreen();
      this.fullscreenLoading = true;
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 2000);
      this.axios({
        url:  this.path + "api/banner/page",
        method:"post",
        params: {
          type: 2
        }
      }).then( (response)=> {
          let sessDta = response.data;
          this.loading.close();
          if(sessDta.code == 200){
            let bannerList = sessDta.data.list;
            this.slideList = [];
            bannerList.forEach((item)=>{
              this.slideList.push(item.picUrl)
            })


          }else {
            this.loading.close();
            this.openError();
          }
          
          
      }).catch( (error)=> {
          this.loading.close();
          this.openError();
      });

      
      
      
    },
    getInformation() {
      this.openFullScreen();
      this.fullscreenLoading = true;
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 2000);
      this.axios({
        url:  this.path + "api/teachingmatin/page",
        method:"post",
        params: {
          pageNum: 1,
          pageSize: 10,
          title: ''
        }
      }).then( (response)=> {
          let sessDta = response.data;
          this.loading.close();
          if(sessDta.code == 200){
            this.inforList = sessDta.data.list;
           
          }else {
            this.loading.close();
            this.openError();
          }
          
          
      }).catch( (error)=> {
          this.loading.close();
          this.openError();
      });

      
      
      
    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // setTimeout(() => {
      //   this.loading.close();
      // }, 2000);
    },
    openError() {
      this.$alert('网络异常', '', {
        confirmButtonText: '确定',
        center: true,
      });
    }

  },
};
</script>

<style scoped>
.superiorityTitle {
  width: 140px;
  margin: 0 auto;
  font-size: 30px;
  font-weight: 700;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px #39a9ff solid;
}
.superiorityDiv {
  width: 100%;
  background-color: #ebeae8;
  padding: 20px 0;
}
.superiorityImg {
  width: 1080px;
  margin: 20px auto 0;
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;
}

.superiorityImg img {
  display: block;
  margin: 0 auto;
  padding-bottom: 20px;
  border-bottom: 2px #39a9ff solid;
}

.curriculumSystem {
  width: 100%;
  background-color: #373a6d;
  height: 700px;
  margin: 0 auto;
}

.curriculumSystemDiv {
  width: 1080px;
  margin: 0 auto;
}

.curriculumTitle {
  width: 200px;
  margin: 0 auto;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  line-height: 60px;
  border-bottom: 1px #cd9f59 solid;
  color: #ffffff;
  padding-top: 20px;
}
.curriculumSystemDiv .titleExplain {
  position: relative;
  width: 1080px;
  height: 10px;
  border-bottom: 1px #cd9f59 solid;
  margin: 40px auto;
}
.curriculumSystemDiv .titleExplainDiv {
  position: absolute;
  width: 360px;
  height: 30px;
  background-color: #373a6d;
  top: -5px;
  left: 380px;
  padding-left: 20px;
}
.curriculumSystemDiv .titleExplainDiv span {
  font-size: 20px;
  font-weight: 700;
  padding-left: 5px;
  padding-right: 5px;
}
.curriculumSystemDiv .titleExplainDiv .left {
  color: #fabe53;
}
.curriculumSystemDiv .titleExplainDiv .right {
  color: #ffffff;
}
.curriculumSystemDiv .titleExplainImg {
  position: absolute;
  width: 100%;
  margin: 0 auto;
  top: 40px;
}
.curriculumSystemDiv img {
  display: block;
  width: 100%;
}
.eduInformationDiv {
  width: 100%;
  margin: 20px auto;
}
.informationDiv {
  width: 1200px;
  margin: 40px auto;
  padding: 20px 20px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 20px;
  background-color: #DCE8FD;
}
.inforContentDiv {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  
}
.inforContentDiv .informationLeft {
  width: 350px;
  padding: 0 10px;
  margin: 20px auto;
  text-align: left;
  line-height: 30px;
}

.inforTopImg {
  width: 100%;
  margin-bottom: 20px;
}

.inforTopImg img {
  width: 100%;
  height: 148px;
}

.inforDetailDiv {
  width: 100%;
  margin-bottom: 20px;
  height: 148px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.inforLeft {
  flex-shrink: 0;
  margin-right: 10px;
  text-align: center;
}

.inforLeft img {
  width: 26px;
  vertical-align: middle;
}

.topDiv {
  font-size: 16px;
  letter-spacing: 2px;
  color: #ff0000;
  font-weight: 700;
}

.topNum {
  font-size: 25px;
  font-weight: 700;
  color: #ffaa06;
  letter-spacing: 1px;

}

.inforRight {
  width: 100%;
  flex-shrink: 1;
}

.inforRight .inforName {
  font-size: 20px;
  color: #333;
  font-weight: 700;
  height: 60px;
  line-height: 30px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.inforRight .inforRemark {
  font-size: 15px;
  color: #808081;
  line-height: 25px;
  height: 50px;
  margin-top: 10px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.infortime {
  font-size: 14px;
  color: #bdbdbe;
  text-align: right;
  line-height: 30px;
}



.informationTime {
  float: right;
  /* font-size: 14px; */
}
.informationDiv .informationRight {
  width: 50%;
}
.informationTitle {
  width: 380px;
  word-break: break-all;
  display: inline-block;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.swiper-page {
  position: relative;
}

.swiper-page img {
  width: 100%;
}

.lookMore {
  /* margin: 10px auto; */
  text-align: center;
}

.lookMore a {
  color: #ff0000;
  font-weight: 700;
  letter-spacing: 2px;
}






</style>
